import React, { useState, useEffect } from "react";

import NavBar from "../../../../Member/Navbar/Navbar";
import Stepper from "./Stepper";
import "./Message.css";
import { Container, Row, Col } from "react-bootstrap";
import photoMessage from "./message.svg";
import ServiceAdmin from "../../Services/ServiceAdmin";

const Message = () => {
  const [count, setCount] = useState(2);
  useEffect(() => {
    setCount(3);
  });

  const healthProId = JSON.parse(sessionStorage.getItem("user")).id;
  useEffect(() => {
    getprofileInfo();
  }, []);

  //
  const getprofileInfo = () => {
    ServiceAdmin.getprofile(healthProId).then((res) => {
      console.log("api get ", res.data);
      if (res.data) {
        sessionStorage.setItem("profSante", JSON.stringify(res.data));
        sessionStorage.setItem(
          "dataCabinet",
          JSON.stringify(res.data.laboratory ? res.data.laboratory : {})
        );
        // setDetailsInfo(JSON.parse(res.data.laboratory));
      }
    });
  };

  return (
    <>
      <div className="message">
        <NavBar Message="active" />
        <Stepper count={count} />
        <Container>
          <div className="card">
            {" "}
            <Row>
              <Col>
                <img
                  src={photoMessage}
                  width="40%"
                  alt="birthday"
                  class="birthday"
                />
              </Col>
              <Col>
                <div class="text">
                  <h2>Message </h2>
                  <p>
                    Un paragraphe est une section de texte en prose vouée au
                    développement d'un point particulier souvent au moyen de
                    plusieurs phrases, dans la continuité du précédent et du
                    suivant. Sur le plan typographique, le paragraphe est
                    compris entre deux alinéas, qui s'analysent aussi comme une
                    « ponctuation blanche{" "}
                  </p>
                  <p class="muted">- Jonah Lawrence</p>
                </div>
              </Col>
            </Row>
            <div class="space"></div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Message;
